// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__38Vb4","footer":"ModalError_footer__9zHhD"};